import React from 'react';
import { observer } from 'mobx-react';
import classes from 'classnames';
import {
    AnswerableToggleButton,
    AnswerableToggleButtonGroup,
} from './components/buttons';
import { useTranslation, Trans } from 'react-i18next';
import { translatableResourcePath } from '../../utils/helpers';
import { QuestionHeading } from './question-heading';

export const Questionwithimage = observer(
    ({ ui, handleChange, value, answer }) => {
        const { t } = useTranslation('assessment');
        const [imageZoomed, setIsImageZoomed] = React.useState(false);

        const handleToggle = (event, newValue) => {
            handleChange(newValue);
        };

        const handleImageClick = () => {
            setIsImageZoomed(!imageZoomed);
        };

        return (
            <div className={classes('assessment')}>
                <div className={'assessment-question'}>
                    <QuestionHeading ui={ui} />
                    <div
                        className={classes('image', {
                            clickable: ui.imageZoom,
                        })}
                    >
                        {ui.imageZoom && (
                            <img
                                src={translatableResourcePath(ui.image, t)}
                                alt="illustration"
                                onClick={handleImageClick}
                            />
                        )}
                        {!ui.imageZoom && (
                            <img
                                src={translatableResourcePath(ui.image, t)}
                                alt="illustration"
                            />
                        )}
                    </div>
                    <div
                        className="image-zoomed"
                        onClick={handleImageClick}
                        style={{
                            opacity: imageZoomed ? '1' : '0',
                            visibility: imageZoomed ? 'visible' : 'hidden',
                        }}
                    >
                        <img
                            src={translatableResourcePath(ui.imageZoom, t)}
                            alt="illustration"
                            onClick={handleImageClick}
                        />
                    </div>
                    <br />
                    <AnswerableToggleButtonGroup
                        handleToggle={handleToggle}
                        value={value}
                        fullWidth={true}
                    >
                        {ui.options.map((v, i) => {
                            return (
                                <AnswerableToggleButton
                                    key={'select-' + i}
                                    name={'select-' + i}
                                    value={v.value}
                                    text={t(v.text)}
                                    answer={answer}
                                    selected={value === v.value}
                                    handleToggle={handleToggle}
                                    oneOf={ui.options.length} //How many buttons in total, used to give them equal width
                                />
                            );
                        })}
                    </AnswerableToggleButtonGroup>
                </div>
            </div>
        );
    }
);
